<script lang="ts">
export default {
  name: 'Chip',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    /** Optional text to render inside the chip. If omitted, the default slot is used. */
    label?: string;
    /** Visual style of the chip. */
    variant?: 'solid' | 'outline';
    /** Additional Tailwind classes to control colors (e.g. 'tw:bg-primary tw:text-white'). */
    colorClass?: string;
    /** Size of the chip. */
    size?: 'sm' | 'md';
    /** Extra classes to append to the chip container. */
    class?: string;
  }>(),
  {
    variant: 'solid',
    size: 'md',
  },
);

const baseClasses = computed(() => {
  const classes = [
    'tw:inline-flex',
    'tw:items-center',
    'tw:justify-center',
    'tw:rounded',
    'tw:font-bold',
    'tw:uppercase',
    'tw:tracking-wide',
  ];

  // Size
  if (props.size === 'sm') {
    classes.push('tw:px-2', 'tw:py-0.5', 'tw:text-xs');
  } else {
    classes.push('tw:px-2.5', 'tw:py-1', 'tw:text-xs');
  }

  // Variant
  if (props.variant === 'outline') {
    classes.push('tw:border', 'tw:border-current', 'tw:bg-transparent');
  }

  if (props.colorClass) {
    classes.push(props.colorClass);
  }

  if (props.class) {
    classes.push(props.class);
  }

  return classes.join(' ');
});
</script>

<template>
  <span :class="baseClasses">
    <slot>
      {{ label }}
    </slot>
  </span>
</template>

